import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { CartProvider } from "@/lib/cart";
import Landing from "@/pages/Landing";
import Booking from "@/pages/Booking";
import Confirmation from "@/pages/Confirmation";
import Tracker from "@/pages/Tracker";
import AdminLogin from "@/pages/AdminLogin";
import AdminInsights from "@/pages/AdminInsights";
import AdminJobs from "@/pages/AdminJobs";
import AdminJobDetail from "@/pages/AdminJobDetail";
import AdminServices from "@/pages/AdminServices";
import AdminShop from "@/pages/AdminShop";
import AdminOrderDetail from "@/pages/AdminOrderDetail";
import AdminNotifications from "@/pages/AdminNotifications";
import AdminSettings from "@/pages/AdminSettings";
import AdminReviews from "@/pages/AdminReviews";
import AdminCustomers from "@/pages/AdminCustomers";
import AdminCustomerDetail from "@/pages/AdminCustomerDetail";
import AdminChecklistTemplates from "@/pages/AdminChecklistTemplates";
import AdminInterest from "@/pages/AdminInterest";
import Reviews from "@/pages/Reviews";
import Services from "@/pages/Services";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import Terms from "@/pages/Terms";
import HowToPay from "@/pages/HowToPay";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import { getAdminToken } from "@/lib/api";
import InstallAppPrompt from "@/components/InstallAppPrompt";

const RequireAdmin = ({ children }) => {
  const token = getAdminToken();
  if (!token) return <Navigate to="/admin/login" replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <CartProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/services" element={<Services />} />
            <Route path="/book" element={<Booking />} />
            <Route path="/confirmation/:ref" element={<Confirmation />} />
            <Route path="/track" element={<Tracker />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/how-to-pay" element={<HowToPay />} />
            <Route path="/reviews" element={<Reviews />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/shop/p/:slug" element={<ProductDetail />} />
            <Route path="/shop/cart" element={<Cart />} />
            <Route path="/shop/success" element={<CheckoutSuccess />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<RequireAdmin><AdminInsights /></RequireAdmin>} />
            <Route path="/admin/jobs" element={<RequireAdmin><AdminJobs /></RequireAdmin>} />
            <Route path="/admin/jobs/:id" element={<RequireAdmin><AdminJobDetail /></RequireAdmin>} />
            <Route path="/admin/services" element={<RequireAdmin><AdminServices /></RequireAdmin>} />
            <Route path="/admin/shop" element={<RequireAdmin><AdminShop /></RequireAdmin>} />
            <Route path="/admin/orders/:id" element={<RequireAdmin><AdminOrderDetail /></RequireAdmin>} />
            <Route path="/admin/notifications" element={<RequireAdmin><AdminNotifications /></RequireAdmin>} />
            <Route path="/admin/settings" element={<RequireAdmin><AdminSettings /></RequireAdmin>} />
            <Route path="/admin/reviews" element={<RequireAdmin><AdminReviews /></RequireAdmin>} />
            <Route path="/admin/customers" element={<RequireAdmin><AdminCustomers /></RequireAdmin>} />
            <Route path="/admin/customers/:email" element={<RequireAdmin><AdminCustomerDetail /></RequireAdmin>} />
            <Route path="/admin/checklist-templates" element={<RequireAdmin><AdminChecklistTemplates /></RequireAdmin>} />
            <Route path="/admin/interest" element={<RequireAdmin><AdminInterest /></RequireAdmin>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="bottom-left" />
          <InstallAppPrompt />
        </BrowserRouter>
      </CartProvider>
    </div>
  );
}

export default App;
